<template>
  <div class="">
    <import-map-transfer />
  </div>
</template>

<script>
import ImportMapTransfer from "@/components/profile/import-maps/broker/transfer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    ImportMapTransfer,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Migra Mappatura",
        path: "import_maps.transfer",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Migra Mappatura",
        path: "import_maps.transfer",
        level: 3,
      });
    }
  },
};
</script>
